import {
  QueryClient,
  QueryCache,
  MutationCache,
  type UseMutationOptions,
  type UseMutationResult,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';

export type QueryHandler<TData, TParams = void> = [TParams] extends [void]
  ? (
      options?: Omit<UseQueryOptions<TData, Error>, 'queryKey' | 'queryFn'>
    ) => UseQueryResult<TData, Error>
  : (
      params: TParams,
      options?: Omit<UseQueryOptions<TData, Error>, 'queryKey' | 'queryFn'>
    ) => UseQueryResult<TData, Error>;

export type MutationHandler<TData, TVariables> = (
  options?: Omit<
    UseMutationOptions<TData, Error, TVariables, unknown>,
    'mutationFn' | 'mutationKey'
  >
) => UseMutationResult<TData, Error, TVariables>;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      console.error(
        `Query error: ${error instanceof Error ? error.message : 'unknown'}`
      );
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      console.error(
        `Mutation error: ${error instanceof Error ? error.message : 'unknown'}`
      );
    },
  }),
});
